/** @jsxImportSource theme-ui */
import { Container, Box, Flex } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import Invoices from '@/containers/voss/Invoices';
import Button from '@/components/Button';

const VossBalancePage = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Flex sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => {
                            navigate('/voss/invoice/new');
                        }}
                    >
                        Create invoice job
                    </Button>
                </Flex>

                <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                    <Box
                        sx={{
                            borderRadius: 'sm',
                            overflowY: 'scroll',
                            zIndex: 2,
                            justifySelf: 'left',
                            width: '100%',
                            backgroundColor: 'background',
                            padding: 2,
                            position: 'relative',
                        }}
                    >
                        <Invoices />
                    </Box>
                </Flex>
            </Flex>
        </Container>
    );
};

export default VossBalancePage;
